import { render, staticRenderFns } from "./ProductDes.vue?vue&type=template&id=26181896&scoped=true&"
import script from "./ProductDes.vue?vue&type=script&lang=ts&"
export * from "./ProductDes.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDes.vue?vue&type=style&index=0&id=26181896&lang=less&scoped=true&"
import style1 from "./ProductDes.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26181896",
  null
  
)

export default component.exports